import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '../shared/shared.module'
import { FreeTextComponent } from './free-text.component'
import { PipesModule } from '../../pipes/pipes.module'

@NgModule({
  imports: [CommonModule, SharedModule, PipesModule],
  declarations: [FreeTextComponent],
  exports: [FreeTextComponent],
})
export class FreeTextModule {}
